<script lang="ts">import { AsyncServerState, ServerState } from "./api/api";
import { AbTest, CatalogFilter, cfgApiBase, cfgAppName, cfgAppVersion, EndpointType, FeatureSet, getEndpoint, getEndpointOptions, ReleaseStage, stateAbTest, stateCatalogFilter, stateEndpointType, stateFeatureSet, stateRealm, stateReleaseStage, stateTheme, Theme } from "@infinitro/config";
import { Dropdown } from "@infinitro/dropdown";
import { closeThisModal, ModalDialog, stateOpenModal, theme } from "@infinitro/global";
import { Modal } from "@infinitro/modal";
import { onMount } from "svelte";
import { derived } from "svelte/store";
export const thisModal = ModalDialog.DevSettings;
const closeModal = () => closeThisModal(thisModal);
function changeAbTest(event) {
	console.log("changeAbTest", event.detail);
	stateAbTest.set(event.detail);
	window.location.reload();
}
function changeFeatures(event) {
	console.log("changeFeatures", event.detail);
	stateFeatureSet.set(event.detail);
	window.location.reload();
}
function changeCatalogFilter(event) {
	console.log("changeCatalogFilter", event.detail);
	stateCatalogFilter.set(event.detail);
	window.location.reload();
}
function changeEndpointType(event) {
	console.log("changeEndpointType", event.detail);
	stateEndpointType.set(event.detail);
	window.location.reload();
}
function changeReleaseStage(event) {
	console.log("changeReleaseStage", event.detail);
	stateReleaseStage.set(event.detail);
	window.location.reload();
}
function changeTheme(event) {
	console.log("changeTheme", event.detail);
	stateTheme.set(event.detail);
	window.location.reload();
}
let serverState;
let dynamicEndpointOptions = derived([stateTheme], ([$stateTheme]) => {
	return getEndpointOptions($stateTheme);
});
onMount(async () => {
	try {
		const result = await AsyncServerState({});
		serverState = result?.data?.health;
	} catch (e) {
		console.log(`api error ${e?.message ?? "unknown"}`);
	}
});
$: console.log(serverState);
</script>

{#if $stateOpenModal === ModalDialog.DevSettings}
	<Modal
		{closeModal}
		width="50vw"
		maxWidth="100vw"
		height="50vh"
		maxHeight="100vh"
		padding="20px 20px 20px 20px"
	>
		<h1>Developer Settings</h1>
		{cfgAppName()}
		{cfgAppVersion()}<br />
		{cfgApiBase()} [{serverState?.appVersion}] - {$stateRealm}<br />
		{#if theme === Theme.Flush || theme === Theme.Generic}
			<p>
				<Dropdown
					size="small"
					options={[
						{ label: 'Flush', value: Theme.Flush },
						{ label: 'Generic', value: Theme.Generic },
						{ label: 'Fomo', value: Theme.Fomo },
						{ label: 'Luna', value: Theme.Luna },
						{ label: 'Rocketbet', value: Theme.Rocketbet },
						{ label: 'Turboslots', value: Theme.Turboslots }
					]}
					value={$stateTheme}
					width="200px"
					on:change={changeTheme}
				/>
			</p>
		{/if}
		<p>
			<Dropdown
				size="small"
				options={[
					{ label: 'Alpha', value: ReleaseStage.Alpha },
					{ label: 'Beta', value: ReleaseStage.Beta },
					{ label: 'Gamma', value: ReleaseStage.Gamma },
					{ label: 'Internal', value: ReleaseStage.Internal },
					{ label: 'EarlyAccess', value: ReleaseStage.EarlyAccess },
					{ label: 'General', value: ReleaseStage.General }
				]}
				value={$stateReleaseStage}
				width="200px"
				on:change={changeReleaseStage}
			/>
		</p>
		<p>
			<Dropdown
				size="small"
				options={[
					{ label: 'Preview', value: FeatureSet.Preview },
					{ label: 'Release', value: FeatureSet.Release }
				]}
				value={$stateFeatureSet}
				width="200px"
				on:change={changeFeatures}
			/>
		</p>
		<p>
			<Dropdown
				size="small"
				options={$dynamicEndpointOptions.map((e) => ({
					label: e.endpointType,
					value: e.endpointType
				}))}
				value={getEndpoint().endpointType}
				width="200px"
				on:change={changeEndpointType}
			/>
		</p>
		<p>
			<Dropdown
				size="small"
				options={[
					{ label: 'Release Games', value: CatalogFilter.ReleaseGames },
					{ label: 'All Games', value: CatalogFilter.AllGames },
					{ label: 'All Providers', value: CatalogFilter.AllProviders }
				]}
				value={$stateCatalogFilter}
				width="200px"
				on:change={changeCatalogFilter}
			/>
		</p>
		<p>
			<Dropdown
				size="small"
				options={[
					{ label: 'AB/Test = A', value: AbTest.A },
					{ label: 'AB/Test = B', value: AbTest.B },
					{ label: 'AB/Test = C', value: AbTest.C },
					{ label: 'AB/Test = D', value: AbTest.D }
				]}
				value={$stateAbTest}
				width="200px"
				on:change={changeAbTest}
			/>
		</p>
	</Modal>
{/if}

<style>
	h1 {
		margin: 0 0 20px 0;
		font-size: 16pt;
	}
	p {
		margin: 10px 0 10px 0;
	}
</style>
